// Class: openfl.display.JPEGEncoderOptions

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $hxEnums = require("./../../hxEnums_stub").default;

// Constructor

var JPEGEncoderOptions = function(quality) {
	if(quality == null) {
		quality = 80;
	}
	this.quality = quality;
}

// Meta

JPEGEncoderOptions.__name__ = "openfl.display.JPEGEncoderOptions";
JPEGEncoderOptions.__isInterface__ = false;
JPEGEncoderOptions.prototype = {
	
};
JPEGEncoderOptions.prototype.__class__ = JPEGEncoderOptions.prototype.constructor = $hxClasses["openfl.display.JPEGEncoderOptions"] = JPEGEncoderOptions;

// Init



// Statics




// Export

exports.default = JPEGEncoderOptions;